module.exports = __webpack_public_path__ + "img/red.0fdaef87.png";